import moment from 'moment';

/**
 * Checks if the current UTC date is within a given range.
 * @param {string} startDate - Start date in 'YYYY-MM-DD HH:mm' format.
 * @param {string} endDate - End date in 'YYYY-MM-DD HH:mm' format.
 * @returns {boolean} - True if current date is within the range.
 */
export const isNowBetween = (startDate: string, endDate: string) => {
  const now = moment.utc();
  const start = moment.utc(startDate, 'YYYY-MM-DD HH:mm');
  const end = moment.utc(endDate, 'YYYY-MM-DD HH:mm');
  return now.isBetween(start, end, undefined, '[]'); // inclusive
};
